import React from 'react';
import { createComponent } from '@lit-labs/react';

import Dsy from './dsyui';

const LitComp = Dsy.components.DsyTimePicker;

export const DsyTimePicker = createComponent(
  React,
  'dsy-time-picker',
  LitComp,
  {},
);

export default DsyTimePicker;
